export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_e762b06f-568d-4786-9505-9816e9fb7bba/artifacts/hfnrxvaq_IMG_2114.png",
  heroMedals: "https://customer-assets.emergentagent.com/job_e762b06f-568d-4786-9505-9816e9fb7bba/artifacts/xmvdwibs_669054E2-80B9-4B03-B5F8-C8843638C614.jpeg",
  training: "https://customer-assets.emergentagent.com/job_e762b06f-568d-4786-9505-9816e9fb7bba/artifacts/lhga6u2n_C244D8D8-1C61-4F62-BD7A-E67BB92BFC9F.jpeg",
  team: "https://customer-assets.emergentagent.com/job_e762b06f-568d-4786-9505-9816e9fb7bba/artifacts/m1xa4bmo_IMG_2120.jpeg",
  drills: "https://customer-assets.emergentagent.com/job_e762b06f-568d-4786-9505-9816e9fb7bba/artifacts/7hympmdb_8CD578D0-322A-470D-9E1B-17D6919E1BD7.jpeg",
  featuredCamp: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/jkczrlxk_OHF%20camp%20web.webp",
  proclamation: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/1pkuylx8_817%20group.webp",
  champVideo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/j51oan6c_champ.mp4",
  drillsVideo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/s1u486zq_drills.mp4",
  collageVideo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/lkkf9yc7_ourhve%20collage.MP4",
  legsVideo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/5cq2xfvj_web%20legs.mp4",
  heroCircle: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hovse-youth-movement/artifacts/25axrs71_circle.webp",
};

export const PROGRAMS = [
  {
    key: "speed-agility",
    title: "Speed & Agility",
    description: "Build coordination, balance, confidence, and athletic fundamentals through fun, age-appropriate movement and skill development.",
    icon: "Zap",
  },
  {
    key: "strength-conditioning",
    title: "Strength & Conditioning",
    description: "Develop healthy habits, endurance, and physical confidence while learning discipline, consistency, and goal setting.",
    icon: "Dumbbell",
  },
  {
    key: "nutrition-healthy-habits",
    title: "Nutrition & Healthy Habits",
    description: "Teaching young people how to fuel their bodies, make healthier choices, and build lifelong wellness habits.",
    icon: "Apple",
  },
  {
    key: "community-experiences",
    title: "Community Experiences",
    description: "Family fitness days, service projects, special events, and community partnerships that help young people build lasting relationships and a sense of belonging.",
    icon: "Users",
  },
];
